<template>
	<div>
        <div class="mt-20 mb-20">
            <el-row>
                <el-col>
                    <template>
                        <el-date-picker class="mr-5 mb-10"
                            style="top: 2px !important; width:220px;"
                            range-separator="to"
                            size="mini"
                            type="daterange"
                            placeholder="Pick a day"
                            v-model="selectedStartDatePicGroup"
                        >
                        </el-date-picker>
                        <el-input
                            style="width:250px;"
                            class="mb-10"
                            size="mini"
                            prefix-icon="el-icon-search"
                            placeholder="Input PIC Name"
                            v-model="searchPicBusiness"
                            clearable
                            @clear="loadData"
                        >
                        </el-input>
                        <el-button-group class="mr-10 ml-5">
                            <el-button
                                type="primary"
                                size="mini"
                                class="animated fadeInRight"
                                :loading="loadingPic"
                                @click="changeFilterPicBusiness"
                                target="_blank"
                            >
                                <i class="el-icon-search"/>
                            </el-button>
                        </el-button-group>
                        <el-button-group class="mr-10 ml-5">
                            <el-tooltip content="Download all data PIC Business" placement="top">
                                <el-button
                                    type="primary"
                                    size="mini"
                                    @click="downloadAllPic"
                                    :loading="loadingDownloadAll"
                                >
                                    <i v-if="!loadingDownloadAll" class="mdi mdi-download" />
                                </el-button>
                            </el-tooltip>
                        </el-button-group>
                    </template>
                </el-col>
		    </el-row>
        </div>
        <div>
            <el-table :data="dataPicBusiness" style="width: 100%;" v-loading="loadingTemplate" element-loading-text="Loading..." element-loading-spinner="el-icon-loading">
                <el-table-column prop="pic_business" label="PIC Business" width="300">
                    <template slot-scope="props">
                        <p v-if="props.row.pic_business">{{props.row.pic_business}}</p>
                        <p v-else-if="!props.row.pic_business">-</p>
                    </template>
                </el-table-column>
                <el-table-column label="Total Revenue" width="400">
                    <template slot-scope="props">
                        <p>{{sumDocNum(props.row)}}</p>
                    </template>
                </el-table-column>
                <el-table-column
                    fixed="right"
                    label="Action"
                    width="200">
                    <template slot-scope="props">
                        <el-tooltip content="Download data per PIC Business" placement="top">
                            <el-button
                                    type="primary"
                                    size="mini"
                                    :loading="props.row.customerId === loadingDownloadPic ? true : false"
                                    @click="downloadPic(props.row)"
                                >
                                <i v-if="props.row.customerId !== loadingDownloadPic" class="mdi mdi-download" />
                            </el-button>
                        </el-tooltip>
                    </template>
                </el-table-column>
		    </el-table>
        </div>
    </div>
</template>

<script>
import api from '@/networkClient'
import config from '@/config'
const _ = require('lodash')
const moment = require('moment')

export default {
	name: 'PIC_Business',
    props: {
        dataPic: {
            type: Array
        },
        loadingData: {
            type: Boolean
        }
    },
	data () {
		return {
			paginate: true,
			bodyStyle: {
				padding: "20px"
			},
            dataPicBusiness: [],
            loadingTemplate: false,
            totalData: 0,
            selectedStartDatePicGroup: [
                moment().subtract(1,"day").format("YYYY-MM-DD"),
                moment().subtract(1,"day").format("YYYY-MM-DD")
            ],
            searchPicBusiness: '',
            loadingPic: false,
            loadingDownloadAll: false,
            loadingDownloadPic: '',
            loadingDownloadPicArr: []
		}
	},
    components: {
    },
	methods: {
        log(message) {
            console.log(message, " <<message");
        },
        changeFilterPicBusiness() {
            // function button click filter
            if(this.selectedStartDatePicGroup) {
                let today = moment(this.selectedStartDatePicGroup[1]), diff = today.diff(moment(this.selectedStartDatePicGroup[0]), 'd')
                if(diff > 30) {
                    this.$swal(
                        this.$t('info'),
                        "Can't set filter date more than 30 days.",
                        "info"
                    )
					return
                }
            }
            this.picBusiness();
        },
        downloadAllPic() {
            this.picBusiness(true);
        },
        downloadPic(data) {
            var picName =
                data &&
                data.pic_business
                    ? data.pic_business
                    : '';
            var customerId =
                data &&
                data.customerId
                    ? data.customerId
                    : ''
            this.picBusiness(false, true, picName, customerId);
        },
        sumDocNum(data) {
            // function count revenue bi + revenue ui
			let sum = 0
            sum = +data.revenue_bi + +data.revenue_ui
			return this.formatPrice(+sum)
		},
        formatPrice(val){
            // function format number to rupiah
			return new Intl.NumberFormat("id-ID", { style: "currency", currency: "IDR", minimumFractionDigits: 0 }).format(val);
		},
        picBusiness(downloadAll = false, downloadPic = false, picName, customerId) {
            // function hit api get filter pic business
            const today = moment().subtract(1,"day").format("YYYY-MM-DD");
            const startDate = moment(this.selectedStartDatePicGroup[0]).format('YYYY-MM-DD');
            const endDate = moment(this.selectedStartDatePicGroup[1]).format('YYYY-MM-DD');

            let apiOptions = {
                url: config.baseApi + "bussiness/get-fb-sessions-group",
                method: "GET",
                params: {
                    search: this.searchPicBusiness,
                    download: downloadAll || downloadPic ? true : null,
                    startDate: moment(this.selectedStartDatePicGroup[0]).format("YYYY-MM-DD") || null,
                    endDate: moment(this.selectedStartDatePicGroup[1]).format("YYYY-MM-DD") || null
                }
            }

            if(downloadAll) {
                apiOptions.params.startDate = null
                apiOptions.params.endDate = null
                this.loadingDownloadAll = true;
            }

            if(downloadPic && this.selectedStartDatePicGroup[0] === today && this.selectedStartDatePicGroup[1] === today) {
                apiOptions.params.search = picName
                this.loadingDownloadPic = customerId;
                apiOptions.params.startDate = null
                apiOptions.params.endDate = null
            } else if (downloadPic && this.selectedStartDatePicGroup[0] !== today && this.selectedStartDatePicGroup[1] !== today) {
                apiOptions.params.search = picName
                this.loadingDownloadPic = customerId;
                apiOptions.params.startDate = this.selectedStartDatePicGroup[0]
                apiOptions.params.endDate = this.selectedStartDatePicGroup[1]
            }

            let allTime = false;

            if (
                this.selectedStartDatePicGroup[0] === today &&
                this.selectedStartDatePicGroup[1] === today
            ) {
                allTime = true
            }

            api(
                apiOptions
            ).then(res => {
                if (downloadAll || downloadPic) {
                    const url = window.URL.createObjectURL(new Blob([res.data], { type: res.headers['content-type'] }));
					const link = document.createElement('a');
					link.href = url;
					link.setAttribute(
                        'download',
                        `${downloadAll ?
                         allTime ? 
                            `All_Data_Revenue.csv`
                            : `${startDate} - ${endDate} | Data_Revenue.csv`
                        : allTime ?
                            `Data_Revenue_${picName}.csv`
                            : `${startDate} - ${endDate} | ${picName}.csv`
                        }`
                    );
					link.click();
                    this.loadData();
                }

                var dataPicBusiness =
                    res &&
					res.data &&
					res.data.data &&
					res.data.data.data
						? res.data.data.data
						: [];
                this.dataPicBusiness = dataPicBusiness;
                this.loadingTemplate = false;
                this.loadingDownloadAll = false;
                this.loadingDownloadPic = '';
            }).catch(() => {
                this.$swal(this.$t('info'), this.$t('error_text'), "info")
                this.loadingTemplate = false;
                this.loadingDownloadAll = false;
                this.loadingDownloadPic = '';
                this.loadData();
            })
        },
        loadData() {
            // function hit api get filter pic business load data
            this.selectedStartDatePicGroup = [
                moment().subtract(1,"day").format("YYYY-MM-DD"),
                moment().subtract(1,"day").format("YYYY-MM-DD")
            ]

            api({
                url: config.baseApi + "bussiness/get-fb-sessions-group",
                method: "GET"
            }).then(res => {
                var dataPicBusiness =
                    res &&
					res.data &&
					res.data.data &&
					res.data.data.data
						? res.data.data.data
						: [];
                this.dataPicBusiness = dataPicBusiness
                this.loadingTemplate = false
            }).catch(() => {
                this.loadingTemplate = false
            })
        }
	},
    watch: {
        dataPic: function() {
            this.dataPicBusiness = this.dataPic
            this.loadingDownloadPicArr = this.dataPic
        }
    },
	mounted(){
        this.picBusiness();
    },
    created(){
    }
}
</script>

<style lang="scss" scoped>
.float-image {
	float:right;
	z-index: 1;
	bottom: 10px;
	left: 10px;
}
.fl-r {
	float:right;
}
.gradient-api {
	background:#249393;
	background: linear-gradient(260deg, #4ac5c5, #249393);
}
.white-text {
	color: white;
}
.page-header {
	margin-bottom: 30px;
}
</style>
